var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("validation-provider", {
    attrs: { rules: _vm.rules },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({ errors }) {
            return [
              _c(
                "v-switch",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: {
                        "error-messages": errors,
                        "input-value": _vm.inputValue,
                        inset: "",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("update:inputValue", $event)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          !!_vm.$attrs.label
                            ? {
                                key: "label",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(_vm.$attrs.label) + " "
                                    ),
                                    _vm.rules.includes("true")
                                      ? _c(
                                          "span",
                                          { staticClass: "error--text" },
                                          [_vm._v("*")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    },
                    "v-switch",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                ),
                [
                  _vm._l(Object.keys(_vm.$slots), function (slot) {
                    return _vm._t(slot, null, { slot: slot })
                  }),
                ],
                2
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }